// extracted by mini-css-extract-plugin
export default {"container":"MyOffersContainer_container__cuRIw"};